import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Form
} from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaCalendarAlt, FaEnvelope, FaHistory, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPlus, FaPrint, FaReceipt, FaSearch, FaShoppingCart, FaStore, FaTrash, FaUser, FaUserTag, FaWhatsapp } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import { saleActions } from "../../sagas/saleSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import SupplierList from "../Fournisseur/FournisseurList";
import { supplierActions } from "../../sagas/supplierSlice";
import { supplierProductActions } from "../../sagas/supplierProductSlice";
import { purchaseActions } from "../../sagas/purchaseSlice";

const BuyForm = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [amountPaid, setAmountPaid] = useState(0);
  const cart = useSelector(state => state.purchases?.cart || []);
  const [cartPage, setCartPage] = useState(1);
  const totalAmountHt = useSelector(state => state.purchases?.totalAmountHt || 0);

  console.log('dddddddddddd',totalAmountHt);

  const [newBuy, setNewBuy] = useState({
    totalAmountHt: 0,
    totalAmountTtc: 0,
    advancePayment: 0,
    remainingAmount: 0,
    purchaseStatus: null,
    taxRate: null,
    paymentType: null,
    numberBankCheck: null,
    supplierId: 0,
    supplierName: null,
    supplierCode: null,
    buyingInvoiceNb: null,
  })

  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { company } = useSelector(state => state.auth);
  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    products,
    loading:productsLoading,
    totalPages:productsTotalPages,
    totalElements:productsTotalElements,
    pageNumber:productsPageNumber,
    pageSize:productsPageSize,
    error:productsError,
  } = useSelector((state) => state.products);
  const {
    suppliersProducts,
    loading: suppliersProductsLoading,
    totalPages: suppliersProductsTotalPages,
    totalElements: suppliersProductsTotalElements,
    pageNumber: suppliersProductsPageNumber,
    pageSize: suppliersProductsPageSize,
    error: suppliersProductsError,
  } = useSelector((state) => state.suppliersProducts);

  const {
    suppliers,
    loading: suppliersLoading,
    totalPages: suppliersTotalPages,
    totalElements: suppliersTotalElements,
    pageNumber: suppliersPageNumber,
    pageSize: suppliersPageSize,
    error: suppliersError,
  } = useSelector((state) => state.suppliers);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const [paymentAmount, setPaymentAmount] = useState(0);
  const changeAmount = Math.max(0, paymentAmount - totalAmountHt * 1.2);
  const searchInputRef = useRef(null);
   const [product, setProduct] = useState({
      description: '',
      buyingPrice: '',
      supplierId: '',
      barcode: '',
      stock: '',
    });
   const [newSupplierModal, setNewSupplierModal] = useState(false);
   const [newSupplier, setNewSupplier] = useState({ name: '', contact: '', address: '' });
   const [supplierModal, setSupplierModal] = useState(false);
   const [suppliersPagination, setSuppliersPagination] = useState({ currentPage: 1, pageSize: 10 });
   const [searchQuery, setSearchQuery] = useState('');
   const [selectedSupplier, setSelectedSupplier] = useState(null);


  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  console.log(cart)
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);

  // Add new state
  const [cartCurrentPage, setCartCurrentPage] = useState(1);
  const cartItemsPerPage = 4;
  // Calculate cart pagination
  const cartTotalPages = Math.ceil(cart.length / cartItemsPerPage);
  const cartStartIndex = (cartPage - 1) * cartItemsPerPage;
  const cartEndIndex = cartStartIndex + cartItemsPerPage;
  const currentCartItems = cart.slice(cartStartIndex, cartEndIndex);

  // Cart pagination handlers
  const handleCartPageChange = (page) => {
    setCartPage(page);
  };

  const togglePaymentModal = () => setPaymentModal(!paymentModal);

  const handlePayment = () => {
    // Process payment logic here
    togglePaymentModal();
  };

  const toggleModal = () => setModal(!modal);
  const { t } = useTranslation();

  const formatPrice = (amount) => {
    const formattedPrice = new Intl.NumberFormat('fr-MA', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    }).format(Number(amount) || 0);
    return `${formattedPrice} DH`;
  };

  const itemsPerPage = 6;

useEffect(() => {
    if (selectedSupplier) {
        let payload = {
            criteria: { ...criteria,query: selectedSupplier.code },
            page: currentPage,
            size: suppliersProductsPageSize,
        };
        dispatch(supplierProductActions.search(payload));
    }
}, [currentPage, selectedSupplier, dispatch]);

const handleAddToCart = (product) => {
    dispatch(purchaseActions.addToCart(product));
};


  const handleUpdateQuantity = useCallback((productId, quantity) => {
    dispatch(purchaseActions.updateQuantity({ id: productId, quantity }));
  }, [dispatch]);

  const handleRemoveFromCart = useCallback((productId) => {
    dispatch(purchaseActions.removeFromCart(productId));
    setCartPage((prevPage) => {
      // Calculate new cart length after removal
      const newCartLength = cart.length - 1;
      const newTotalPages = Math.ceil(newCartLength / cartItemsPerPage);

      // If previous page is out of range, move to last valid page (at least 1)
      return prevPage > newTotalPages ? Math.max(1, newTotalPages) : prevPage;
    });
  }, [cart, cartItemsPerPage, dispatch]);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(supplierProductActions.search({
        criteria: { ...criteria,query: selectedSupplier?.code },
        page: 1,
        size: 8,
        onSuccess: () => setIsSearching(false)
      }));
    }, 500), // Wait 500ms after last keystroke
    []
  );

  const handleSupplierPageChange = (page) => {
    setSuppliersPagination(prev => ({ ...prev, currentPage: page }));
    dispatch(supplierActions.search({
        query: searchQuery,
        page,
        size: suppliersPagination.pageSize
    }));
};
  const handleSupplierSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedSupplierSearch(value);
    };


    const handleNewSupplierSubmit = () => {
        dispatch(supplierActions.addSupplier({
            ...newSupplier,
            onSuccess: () => {
                setNewSupplierModal(false);
                dispatch(supplierActions.search({ page: 0, size: 10 }));
                Swal.fire({
                    icon: 'success',
                    title: t('supplier.addSuccess'),
                    timer: 1500
                });
            }
        }));
    };
 const debouncedSupplierSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(supplierActions.search({
                criteria: { query },
                page: 1,
                size: 8,
                onSuccess: () => setIsSearching(false)
            }));
        }, 500), // Wait 500ms after last keystroke
        []
    );
    const handleSupplierSelect = (supplier) => {
        setSelectedSupplier(supplier);
        setSupplierModal(false);
        product.supplierId = supplier.id;
    };
  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(purchaseActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };

const handleSubmit = async (e) => {
    let payload = {
        ...product,
        onSuccess: () => {
            setProductModal(false);
                let payload = {
                    criteria: { ...criteria,query: selectedSupplier.code },
                    page: 1,
                    size: 10,
                }

            dispatch(supplierProductActions.search(payload));
            Swal.fire({
                icon: 'success',
                title: t('product.addSuccess'),
                timer: 1500,
            });
        },
    };
    dispatch(productActions.addProduct(payload));
};

  // Create Sale
  const [clientModal, setClientModal] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const resetForm = () => {
    setProduct({
      name: '',
      price: '',
      barcode: '',
      priceOverride: false,
    });

  };
  const toggleClientModal = () => setClientModal(!clientModal);
  const toggleProductModal = () => setProductModal(!productModal);


  const handleClientSelect = (client) => {
    setSelectedClient(client);
    toggleClientModal();
  };
const handleOpenSupplierModal = () => {
        dispatch(supplierActions.search({
            query: '',
            page: 0,
            size: 10
        }));
        setSupplierModal(true);

    };
console.log('selectedSupplier',selectedSupplier);

  const handleCreateSale = () => {
    if (cart.length === 0) return;

    const totalTtc = totalAmountHt * 1.2;
    const updatedBuy = {
      ...newBuy,
      supplierId: selectedSupplier ? selectedSupplier.id : 0,
      supplierName: selectedSupplier ? selectedSupplier.description : '',
      totalAmountTtc: totalTtc,
      totalAmountHt: totalAmountHt,
    };
    const getCurrentDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      };

    Swal.fire({
      title: t('buy.confirmTitle'),
      html: `
        <div class="text-start p-3">
        <div class="mb-3">
        <label class="form-label">${t('facture.buyingInvoiceNumber')}:</label>
        <input type="text" id="invoiceNbDisplay" class="form-control " placeholder="entrer votre numero de facture d'achat"  >
        </div>
        <div class="mb-3">
        <label class="form-label">${t('facture.invoiceDate')}:</label>
        <input type="date" id="invoiceDateDisplay" class="form-control " value="${selectedSupplier?.buyingDate || getCurrentDate()}" >
        </div>
       <div class="mb-3">
        <label class="form-label">${t('facture.fournisseur.selected')}:</label>
        <input type="text" id="supplierDisplay" class="form-control " value="${selectedSupplier?.description}" disabled>
      </div>
      <div class="mb-3">
          <label class="form-label">${t('cart.totalTtc')}:</label>
          <input type="number" id="montantApayer" class="form-control " value="${totalTtc}" min="${totalTtc}" disabled>
        </div>
        <div class="mb-3">
          <label class="form-label">${t('payment.typePayment')}:</label>
          <select id="paymentType" class="form-control">
            <option value="Payée">${t('payment.pay')}</option>
            <option value="Partiel">${t('payment.partiel')}</option>
            <option value="Non-payée">${t('payment.nonPaye')}</option>
          </select>
        </div>
        <div class="mb-3" id="advancePaymentSection" style="display: none;">
          <label class="form-label">${t('buy.advancePayment')}:</label>
          <input type="number" id="advancePayment" class="form-control text-end" min="0" step="0.01">
        </div>
        <div id="remaindAmountSection" style="display: none;">
          <label class="form-label">${t('buy.remaindPayment')}:</label>
          <input type="text" id="remaindAmount" class="form-control text-end text-success" disabled>
        </div>
        <div class="mb-3">
          <label class="form-label">${t('payment.method')}:</label>
          <select id="paymentMethod" class="form-control">
            <option value="Espèce">${t('payment.cash')}</option>
            <option value="Chèque">${t('payment.cheque')}</option>
            <option value="Virement">${t('payment.virement')}</option>
            <option value="TRAITE">{t('facture.modeReglement.traite')}</option>
          </select>
        </div>
        <div id="numberCheckSection" style="display: none;">
          <label class="form-label">${t('buy.numberCheck')}:</label>
          <input type="text" id="numberCheck" class="form-control text-end text-success" >
        </div>
      </div>
      `,
      didOpen: () => {
        const paymentMethodSelect = document.getElementById('paymentMethod');
        const paymentTypeSelect = document.getElementById('paymentType');
        const numberCheckSection = document.getElementById('numberCheckSection');
        const advancePaymentSection = document.getElementById('advancePaymentSection');
        const remaindAmountSection = document.getElementById('remaindAmountSection');
        const advancePayment = document.getElementById('advancePayment');
        const remaindAmount = document.getElementById('remaindAmount');
        const numberCheck = document.getElementById('numberCheck');

        paymentTypeSelect.addEventListener('change', function () {
          const paymentType = this.value;

          if (paymentType === 'Partiel') {
            advancePaymentSection.style.display = 'block';
            remaindAmountSection.style.display = 'block';
            advancePayment.addEventListener('input', function () {
              const amountPaid = parseFloat(this.value) || 0;
              const remainingAmount = totalTtc - amountPaid;
              remaindAmount.value = formatPrice(remainingAmount.toFixed(2));
              updatedBuy.advancePayment = amountPaid;
              updatedBuy.remainingAmount = remainingAmount;
              updatedBuy.purchaseStatus = paymentType;
            });
          } else {
            advancePaymentSection.style.display = 'none';
            remaindAmountSection.style.display = 'none';
            advancePayment.value = '';
            remaindAmount.value = '';
            updatedBuy.purchaseStatus = paymentType;

          }
        });

        paymentMethodSelect.addEventListener('change', function () {
          const paymentMethod = this.value;
          if (paymentMethod === 'Chèque') {
            numberCheckSection.style.display = 'block';
            numberCheck.addEventListener('input', function () {
                updatedBuy.paymentType = paymentMethod;
                updatedBuy.numberBankCheck = this.value || '';
            });
          } else {
            numberCheckSection.style.display = 'none';
            numberCheck.value = '';
            updatedBuy.purchaseStatus = paymentMethod;
          }
        });

        // Set default value to "payer"
        paymentTypeSelect.value = 'payer';
      },
      preConfirm: () => {
        const montantApayer = document.getElementById('montantApayer').value;
        const paymentType = document.getElementById('paymentType').value;
        const paymentMethod = document.getElementById('paymentMethod').value;
        const invoiceNbDisplay = document.getElementById('invoiceNbDisplay').value;
        updatedBuy.paymentType = paymentMethod;
        updatedBuy.buyingInvoiceNb = invoiceNbDisplay;
        return { montantApayer, paymentType, paymentMethod ,invoiceNbDisplay};
      },
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        const payment = result.value;
        dispatch(purchaseActions.createPurchase({
          items: cart,
          ...updatedBuy,
          onSuccess: (data) => {
            setCartPage(1);
            Swal.fire({
              icon: 'success',
              title: t('buy.successTitle'),
              timer: 3000,
              showConfirmButton: false
            });
            navigate('/purchases/history');
            //setReceiptData(data);
            toggleModal();
          }
        }));
      }
    });
  };


  const handleProductButtonClick = () => {
    if (!selectedSupplier) {
      Swal.fire({
        icon: 'warning',
        title: 'Attention',
        text: 'Vous devez choisir le fournisseur d\'abord',
      });
    } else {
      toggleProductModal();
    }
  };
  const generatePDF = () => {
    const element = document.getElementById('receipt-content');
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.autoPrint();
      window.open(pdf.output('bloburl'), '_blank');
    });
  };

  // Add new handlers
  const handleSaveCart = () => {
    // Save cart logic
  };

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col>
          <Card className="shadow-sm border-0">
            <CardBody className="py-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* Left side - Title */}
                <h4 className="mb-0">
                  <FaShoppingCart className="text-primary me-2" />
                  {t('nav.buy')}
                </h4>
                <Button
                  color="primary"
                  className="d-flex align-items-center"
                  onClick={() => navigate('/purchases/history')}
                  title={t('buy.viewHistory')}
                >
                  <FaHistory className="me-2" />
                  {t('buy.viewHistory')}
                </Button>
                {/* Right side - Breadcrumb */}
                {/* <nav aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/dashboard" className="text-decoration-none">
                        {t('nav.dashboard')}
                      </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {t('nav.sales')}
                    </li>
                  </ol>
                </nav> */}

              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        {/* Product List */}
        <Col md={8} className="pe-4">
          <Card className="shadow-sm h-100">
            <CardBody>
              {suppliersProductsLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (<>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Search Input - Left Side */}
                  <div className="position-relative flex-grow-1 me-3">
                    <Input
                      innerRef={searchInputRef}
                      type="text"
                      placeholder={t('product.searchFocusHint')}
                      value={searchTerm}
                      onChange={handleSearchChange}
                      className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                      title={t('product.searchShortcut')}
                    />
                    <FaSearch
                      style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#adb5bd'
                      }}
                      size={14}
                    />
                    <FaBarcode
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#adb5bd'
                      }}
                      size={20}
                      title={t('product.scanHint')}
                    />
                  </div>
                  <Button
                    color="primary"
                    className="px-2 py-1 me-2"
                    title={t('facture.fournisseur.choseSupplier')}
                    onClick={handleOpenSupplierModal}
                  >
                    <FaUserTag className="me-2" />
                    {t('facture.fournisseur.choseSupplier')}
                  </Button>
                  <Button
                    color="primary"
                    className="px-2 py-1 me-2"
                    title={t('product.newProduct')}
                    onClick={handleProductButtonClick}
                  >
                    <FaPlus className="me-2" />
                    {t('product.newProduct')}
                  </Button>
                </div>
                <div className="table-responsive">
                  <Table bordered hover>
                    <thead>
                      <tr>
                        <th>{t('product.code')}</th>
                        <th>{t('product.description')}</th>
                        <th>{t('product.buyingPrice')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!suppliersProducts || suppliersProducts.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center py-4">
                            <div className="text-muted">
                              {t('product.noProducts')}
                            </div>
                          </td>
                        </tr>
                      ) : (suppliersProducts.map((product) => (
                        <tr key={product.id} onClick={() => handleAddToCart(product)}>
                          <td>{product?.product?.code}</td>
                          <td>{product?.product?.description}</td>
                          <td className="text-end">{formatPrice(product?.buyingPrice)}</td>
                        </tr>
                      ))
                      )}
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <small className="text-muted">
                    {t('product.showing', {
                      start: (currentPage - 1) * productsPageSize + 1,
                      end: Math.min(currentPage * productsPageSize, productsTotalElements),
                      total: productsTotalElements,
                      currentPage: currentPage,
                      totalPages: productsTotalPages
                    })}
                  </small>
                  <Pagination size="sm" className="mb-0">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink first onClick={() => handlePageChange(1)}>
                        <FaAngleDoubleLeft size={12} />
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)}>
                        <FaAngleLeft size={12} />
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === suppliersProductsTotalPages}>
                      <PaginationLink next onClick={() => handlePageChange(currentPage + 1)}>
                        <FaAngleRight size={12} />
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === suppliersProductsTotalPages}>
                      <PaginationLink last onClick={() => handlePageChange(suppliersProductsTotalPages)}>
                        <FaAngleDoubleRight size={12} />
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </div>
              </>)}
            </CardBody>
          </Card>
        </Col>

        {/* Cart */}
        <Col md={4} className="ps-4 border-start">
          <Card className="shadow-sm h-100">
            <div className="card-header bg-light d-flex justify-content-between align-items-center py-3">
              <div className="d-flex align-items-center">
                <div className="position-relative me-2">
                  <FaShoppingCart size={18} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-6px',
                        right: '-10px',
                        fontSize: '0.65rem',
                        width: '16px',
                        height: '16px',
                        padding: 0
                      }}
                    >
                      {cart.reduce((total, item) => total + item.quantity, 0)}
                    </Badge>
                  )}
                </div>
                <h6 className="mb-0 fw-bold">{t('cart.title')}</h6>
              </div>
              {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"

                  onClick={handleClearCart}
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </div>
            <CardBody className="p-0">

              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '150px',
                      opacity: '0.5',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <div className="cart-items p-3">
                    {currentCartItems.map((item) => (
                      <div
                        key={item.id}
                        className="cart-item mb-2 p-2 border rounded bg-light hover-shadow transition"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="flex-grow-1">
                            <div className="fw-bold text-truncate">{item.product.description}</div>
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              <small className="text-primary">{formatPrice(item.buyingPrice * item.quantity)}</small>
                              <div className="quantity-controls bg-white rounded border">
                                <Button
                                  color="light"
                                  size="sm"
                                  className="border-0"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}
                                >
                                  <FaMinus size={10} />
                                </Button>
                                <span className="px-3 fw-bold">{item.quantity}</span>
                                <Button
                                  color="light"
                                  size="sm"
                                  className="border-0"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}
                                >
                                  <FaPlus size={10} />
                                </Button>
                              </div>
                              <Button
                                color="link"
                                className="p-0 ms-2 text-danger"
                                onClick={() => handleRemoveFromCart(item.id)}
                              >
                                <FaTrash />
                              </Button>
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="border-top p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      {cartTotalPages > 1 && (
                        <div className="d-flex justify-content-center mt-2">
                          <Pagination size="sm">
                            <PaginationItem disabled={cartPage === 1}>
                              <PaginationLink previous onClick={() => handleCartPageChange(cartPage - 1)}>
                                <FaAngleLeft size={12} />
                              </PaginationLink>
                            </PaginationItem>

                            <PaginationItem disabled={cartPage === cartTotalPages}>
                              <PaginationLink next onClick={() => handleCartPageChange(cartPage + 1)}>
                                <FaAngleRight size={12} />
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </div>
                      )}
                      <div className="fs-5 fw-bold text-muted ps-2">
                        {t('cart.totalHt')}
                      </div>
                      <div className="fs-4 fw-bold text-primary pe-2">
                        {formatPrice(totalAmountHt)}
                      </div>

                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      
                      <div className="fs-5 fw-bold text-muted ps-2">
                        {t('cart.tax')}
                      </div>
                      <div className="fs-4 fw-bold text-primary pe-2">
                        {formatPrice(totalAmountHt * 0.2)}
                      </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">

                      <div className="fs-5 fw-bold text-muted ps-2">
                        {t('cart.totalTtc')}
                      </div>
                      <div className="fs-4 fw-bold text-primary pe-2">
                        {formatPrice(totalAmountHt * 1.2)}
                      </div>

                    </div>
                    <Button
                      color="success"
                      className="w-100 mt-3 py-2"
                      onClick={handleCreateSale}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('cart.checkout')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Receipt Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>
          {t('receipt.title')}
        </ModalHeader>
        <ModalBody>
          <div
            id="receipt-content"
            className="p-4 bg-white shadow-sm rounded"
            style={{ width: '100%' }}
          >
            {/* Header */}
            <div className="text-center mb-4">
              <h5 className="mb-2">
                <FaStore className="me-2 text-secondary" />
                {company?.name}
              </h5>
              <small className="d-block mb-2">
                <FaMapMarkerAlt className="me-1 text-secondary" />
                {company?.address}
              </small>
              <div className="d-flex justify-content-center align-items-center gap-3">
                {company?.phone && (
                  <small>
                    <FaWhatsapp className="me-1 text-secondary" />
                    {company?.phone}
                  </small>
                )}
                <small>
                  <FaEnvelope className="me-1 text-secondary" />
                  {company?.email}
                </small>
              </div>
            </div>

            <hr />

            {/* Receipt Details */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaReceipt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.receiptNo')} </span>
                  {receiptData?.numero}
                </div>
                <div>
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.date')} </span>
                  {receiptData?.createdAt}
                </div>
              </div>
              <div>
                <FaUser className="me-2 text-secondary" />
                <span className="fw-bold">{t('sale.receipt.cashier')} </span>
                {fullName}
              </div>
            </div>

            <hr />

            {/* Products Table */}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>{t('product.description')}</th>
                  <th className="text-end">{t('sale.receipt.price')}</th>
                  <th className="text-end">{t('sale.receipt.quantity')}</th>
                  <th className="text-end">{t('sale.receipt.total')}</th>
                </tr>
              </thead>
              <tbody>
                {receiptData && receiptData.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.productDescription}</td>
                    <td className="text-end">{formatPrice(item.price)}</td>
                    <td className="text-end">{item.quantity}</td>
                    <td className="text-end">{formatPrice(item.price * item.quantity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr />

            {/* Totals */}
            <div className="text-end mb-4">
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.subtotal')}</span>
                {formatPrice(receiptData.totalAmountTtc)}
              </div> */}
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.tax')}</span>
                {formatPrice(0)}
              </div> */}
              

            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <p className="mb-1">{t('sale.receipt.thankYou')}</p>
              <small className="text-muted">{t('sale.receipt.footer')}</small>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={generatePDF}>
            <FaPrint className="me-1" />
            {t('receipt.printBill')}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal}>
        <ModalHeader toggle={togglePaymentModal}>
          {t('payment.title')}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>{t('payment.totalDue')}</Label>
            <Input
              type="number"
              value={(totalAmountHt * 1.2).toFixed(2)}
              disabled
              className="bg-light"
            />
          </FormGroup>

          <FormGroup>
            <Label>{t('payment.method')}</Label>
            <Input
              type="select"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="cash">{t('payment.cash')}</option>
              <option value="card">{t('payment.card')}</option>
            </Input>
          </FormGroup>

          {paymentMethod === 'cash' && (
            <>
              <FormGroup>
                <Label>{t('payment.amountPaid')}</Label>
                <Input
                  type="number"
                  value={amountPaid}
                  onChange={(e) => setAmountPaid(Number(e.target.value))}
                  min={0}
                  step="0.01"
                />
              </FormGroup>

              {amountPaid > (totalAmountHt * 1.2) && (
                <FormGroup>
                  <Label>{t('payment.change')}</Label>
                  <Input
                    type="number"
                    value={(amountPaid - (totalAmountHt * 1.2)).toFixed(2)}
                    disabled
                    className="bg-light text-success"
                  />
                </FormGroup>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handlePayment}>
            {t('payment.confirm')}
          </Button>
          <Button color="secondary" onClick={togglePaymentModal}>
            {t('payment.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={clearCartModal} toggle={toggleClearCartModal}>
        <ModalHeader toggle={toggleClearCartModal}>
          {t('cart.clearConfirmTitle')}
        </ModalHeader>
        <ModalBody>
          {t('cart.clearConfirmMessage')}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleClearCart}>
            {t('cart.confirm')}
          </Button>
          <Button color="secondary" onClick={toggleClearCartModal}>
            {t('cart.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={clientModal} toggle={toggleClientModal}>
        <ModalHeader toggle={toggleClientModal}>
          {t('client.selectClient')}
        </ModalHeader>
        <ModalBody>
          <SupplierList onSelectClient={handleClientSelect} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleClientModal}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      





       <Modal isOpen={supplierModal} toggle={() => setSupplierModal(false)}>
                      <ModalHeader toggle={() => setSupplierModal(false)}>
                          {t('stock.selectSupplier')}
                      </ModalHeader>
                      <ModalBody>
      
                          {suppliersLoading ? (
      
                              <div className="text-center py-5">
                                  <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">{t('common.loading')}</span>
                                  </div>
                                  <div className="mt-2 text-muted">
                                      {t('common.loadingData')}
                                  </div>
                              </div>
                          ) : (<>
                              <div className="d-flex justify-content-between mb-3">
                                  <Input
                                      placeholder={t('stock.searchSupplier')}
                                      value={searchQuery}
                                      className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                                      onChange={e => handleSupplierSearchChange(e)}
                                  />
                                  <Button
                                      color="primary"
                                      className="ms-2"
                                      onClick={() => setNewSupplierModal(true)}
                                  >
                                      <FaPlus className="me-1" />
                                      {t('supplier.new')}
                                  </Button>
                              </div>
                              <div className="table-responsive">
                                  <Table bordered hover>
                                      <thead>
                                          <tr>
                                              <th>{t('product.code')}</th>
                                              <th>{t('product.description')}</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {!suppliers || suppliers.length === 0 ? (
                                              <tr>
                                                  <td colSpan="6" className="text-center py-4">
                                                      <div className="text-muted">
                                                          {t('product.noProducts')}
                                                      </div>
                                                  </td>
                                              </tr>
                                          ) : (suppliers.map((supplier) => (
                                              <tr key={supplier.id} onClick={() => handleSupplierSelect(supplier)}>
                                                  <td>{supplier.code}</td>
                                                  <td>{supplier.description}</td>
                                              </tr>
                                          ))
                                          )}
                                      </tbody>
                                  </Table>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-3">
                                  <small className="text-muted">
                                      {t('product.showing', {
                                          start: (suppliersPagination.currentPage - 1) * suppliersPagination.pageSize + 1,
                                          end: Math.min(suppliersPagination.currentPage * suppliersPagination.pageSize, suppliersTotalElements),
                                          total: suppliersTotalElements,
                                          currentPage: suppliersPagination.currentPage,
                                          totalPages: suppliersTotalPages
                                      })}
                                  </small>
                                  <Pagination size="sm" className="mb-0">
                                      <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                                          <PaginationLink first onClick={() => handleSupplierPageChange(suppliersPagination.currentPage - 1)}>
                                              <FaAngleDoubleLeft size={12} />
                                          </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                                          <PaginationLink previous onClick={() => handleSupplierPageChange(suppliersPagination.currentPage - 1)}>
                                              <FaAngleLeft size={12} />
                                          </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                                          <PaginationLink next onClick={() => handleSupplierPageChange(suppliersPagination.currentPage + 1)}>
                                              <FaAngleRight size={12} />
                                          </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                                          <PaginationLink last onClick={() => handleSupplierPageChange(suppliersTotalPages)}>
                                              <FaAngleDoubleRight size={12} />
                                          </PaginationLink>
                                      </PaginationItem>
                                  </Pagination>
                              </div>
                          </>)}
                      </ModalBody>
                  </Modal>

                   <Modal isOpen={newSupplierModal} toggle={() => setNewSupplierModal(false)}>
                                  <ModalHeader toggle={() => setNewSupplierModal(false)}>
                                      {t('supplier.new')}
                                  </ModalHeader>
                                  <ModalBody>
                                      {/* <FormGroup>
                                          <Label>{t('supplier.code')}</Label>
                                          <Input
                                              value={newSupplier.code}
                                              onChange={e => setNewSupplier({ ...newSupplier, code: e.target.value })}
                                          />
                                      </FormGroup> */}
                                      <FormGroup>
                                          <Label>{t('supplier.description')}</Label>
                                          <Input
                                              value={newSupplier.description}
                                              onChange={e => setNewSupplier({ ...newSupplier, description: e.target.value })}
                                          />
                                      </FormGroup>
                                      <FormGroup>
                                          <Label>{t('supplier.contact')}</Label>
                                          <Input
                                              value={newSupplier.contact}
                                              onChange={e => setNewSupplier({ ...newSupplier, contact: e.target.value })}
                                          />
                                      </FormGroup>
                                      <FormGroup>
                                          <Label>{t('supplier.address')}</Label>
                                          <Input
                                              type="textarea"
                                              value={newSupplier.address}
                                              onChange={e => setNewSupplier({ ...newSupplier, address: e.target.value })}
                                          />
                                      </FormGroup>
                                  </ModalBody>
                                  <ModalFooter>
                                      <Button color="primary" onClick={handleNewSupplierSubmit}>
                                          {t('common.save')}
                                      </Button>
                                      <Button color="secondary" onClick={() => setNewSupplierModal(false)}>
                                          {t('common.cancel')}
                                      </Button>
                                  </ModalFooter>
                              </Modal>

    </Container >
  );
};

export default BuyForm;
